define('adminSnippetsListRowToolsView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'bootbox',
  'tableFieldView',
  'template!adminSnippetsListRowToolsView'
], function (
  Module,
  App,
  _,
  $,
  Bootbox,
  FieldView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'admin-snippets-list-row-tools-view table-field-view',

    events: {
      'click .btn-delete': 'onDelete'
    },

    serializeData: function () {
      return {
        deleteLabel: _.i18n('common.delete', null, 'Delete')
      };
    },

    onDelete: function (e) {
      e.stopPropagation();
      var self = this;
      Bootbox.confirm(_.i18n('admin.snippets.confirmDelete', null, 'Delete this snippet?'), function (ok) {
        if (!ok) return;
        App.request('snippets:delete', self.model.get('secId')).done(function () {
          var tableView = self.options && self.options.tableView;
          if (tableView && tableView.refresh) tableView.refresh();
        }).fail(function () {
          Bootbox.alert(_.i18n('common.error', null, 'Something went wrong. Please try again.'));
        });
      });
    }
  });
});

